import React from 'react';

export default () => (
  <nav className="header">
    <span className="navbar-brand mb-0 h1">WEB Control Plus</span>
  </nav>
);
